export class Login {
    constructor() {
        this.password = "";
        this.email = "";
        this.longTermLogin = false;
        this.sessionType = "web";
    }
}
//# sourceMappingURL=login.js.map